import React from "react"
import styled from "styled-components"
import { Link } from "react-scroll"
import { T } from "./typography.styles"

export const LinkStyles = styled(Link)`
  ${T.lg.h3.bold}
  cursor: pointer;
  width: 282px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 11px;
  min-height: 46px;
  display: flex !important;
  justify-content: center;
  align-items: center;
  text-align: center;
  letter-spacing: 0.2em;
  justify-self: start;

  background-color: var(--burnt-orange);
  color: var(--white);
  padding: 16px 48px;
  display: inline-block;
  border: none;
  outline: none;
`

const ContactFormLink = ({ text, className }) => {
  return (
    <LinkStyles
      className={className}
      to="contact-form"
      smooth={true}
      duration={1000}
    >
      {text ?? "Contact Us"}
    </LinkStyles>
  )
}

export default ContactFormLink
